const shimmerContainer = {
  padding: 10,
};

const shimmerElement = {
  marginBottom: 10,
};

const footerElement = {
  marginTop: 20,
};

export const getStyles = () => ({
  shimmerContainer,
  shimmerElement,
  footerElement,
});
